import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-accent-700 bg-accent-50 px-3 py-1 rounded-full mb-3">
            热度排行
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            天美影视热度排行榜
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            基于播放量、讨论度和用户评分综合计算的热度排名
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-start gap-4 bg-background-50 border border-background-200/60 rounded-xl p-4 md:p-5 hover:border-primary-200/60 transition-colors cursor-pointer group"
            >
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-background-100 font-heading font-bold text-lg md:text-xl text-foreground-400 group-hover:text-primary-500 group-hover:bg-primary-50 transition-colors">
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading truncate">
                    {item.title}
                  </h3>
                  <span className="flex-shrink-0 text-xs font-bold text-primary-600">
                    {item.heat}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
                <div className="flex items-center gap-3 text-xs">
                  <span className="text-foreground-400">{item.genre}</span>
                  <span className="text-foreground-300">|</span>
                  <span className={`font-medium ${item.update === '已完结' ? 'text-foreground-400' : 'text-primary-600'}`}>
                    {item.update}
                  </span>
                  {item.trend === 'up' && (
                    <i className="ri-arrow-up-line text-accent-500 text-xs"></i>
                  )}
                  {item.trend === 'down' && (
                    <i className="ri-arrow-down-line text-foreground-400 text-xs"></i>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}